import env from '@/utils/env';
import { upload } from './api';
import request from '../../request';

interface IPictureRes {
  localIds: string[];
}
interface ILocalDataRes {
  localData: string;
}

let wxLoadPromise: Promise<void>;
let wxready: Boolean = false;

const loadJS = (url: string): Promise<void> => {
  if (!url) {
    return Promise.reject();
  }
  return new Promise((resolve, reject) => {
    const ele = document.createElement('script');
    ele.src = url;
    ele.onload = () => resolve();
    ele.onerror = () => reject();
    document.head.appendChild(ele);
  });
};

const loadWXJSSDKScript = () => {
  const { wx } = <any>window;
  if (wx) {
    return Promise.resolve(wx);
  }

  if (!wxLoadPromise) {
    wxLoadPromise = loadJS(
      'https://res.wx.qq.com/open/js/jweixin-1.3.2.js',
    ).then(() => (<any>window).wx);
  }
  return wxLoadPromise;
};

if (env.isWeixin || env.isWxMP) {
  loadWXJSSDKScript().then(() => {});
}

/** 获取微信签名 */
const getWeixinSign = (url: string) => {
  return request.post(
    {
      action: 'user.account.getSign',
      url,
      businessType: '13',
    },
    {
      apiServer: 'https://api.hellobike.com/api',
    },
    false,
    false,
    true,
  );
};

/** 注册微信sdk */
const wxsdkConfig = () => {
  return new Promise(async (resolve, reject) => {
    try {
      await loadWXJSSDKScript();
      const { wx, top } = <any>window;
      if (!wx) {
        reject(new Error('load wx jssdk failed'));
      }
      if (wxready) {
        resolve(true);
      }
      const { origin, pathname, search } = top.location || {};
      const url = `${origin}${pathname}${search}`;
      const res = await getWeixinSign(url);
      const { timestamp, nonceStr, signature } = res || {};
      wx.config({
        debug: false,
        appId: 'wx1e65b68915bd1890',
        timestamp,
        nonceStr,
        signature,
        jsApiList: ['chooseImage', 'uploadImage', 'scanQRCode'],
      });
      wx.ready(() => {
        wxready = true;
        resolve(true);
      });
      wx.error((e: unknown) => {
        console.error('wx error--------', e);
        reject(e);
      });
    } catch (e) {
      reject(e);
    }
  });
};

/** 选择图片 */
export function addPhoto(args?: any) {
  return new Promise(async (resolve, reject) => {
    await wxsdkConfig();
    (<any>window).wx.chooseImage({
      sizeType: args?.sizeType || ['compressed'], // 可以指定是原图还是压缩图，默认二者都有
      sourceType: args?.sourceType || ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
      success(res: IPictureRes) {
        resolve({
          data: res.localIds,
        });
      },
      fail(e: unknown) {
        console.log('fail-------------', e);
        reject(e);
      },
    });
  });
}

/** 上传图片 */
export function uploadFile(localId: string) {
  return new Promise(async (resolve, reject) => {
    await wxsdkConfig();
    (<any>window).wx.getLocalImgData({
      localId, // chooseImage返回的localId
      async success(res: ILocalDataRes) {
        // 判断是否有这样的头部，将base64头部删掉
        let localData = res.localData;
        if (localData.indexOf('data:image') === 0) {
          let arr = localData.split(',');
          localData = arr[1];
        }
        // 看到有人踩坑说部分机型会有换行符，所以需要删掉它
        localData = localData.replace(/\r|\n/g, '');
        const url = await upload(localData);
        resolve({
          data: { url },
        });
      },
      fail(e: unknown) {
        reject(e);
      },
    });
  });
}

export async function scan() {
  return new Promise((resolve, reject) => {
    // await wxsdkConfig();
    wxsdkConfig()
      .then(() => {
        console.warn('scan start:::::');
        window.wx &&
          window.wx.scanQRCode({
            needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
            scanType: ['qrCode'], // 可以指定扫二维码还是一维码，默认二者都有
            success(res) {
              resolve({
                data: {
                  result: res.resultStr,
                },
              });
            },
            fail(e) {
              reject(e);
            },
          });
      })
      .catch((e) => {
        reject(e);
      });
  });
}

export async function getLocation() {
  return new Promise((resolve, reject) => {
    // await wxsdkConfig();
    wxsdkConfig()
      .then(() => {
        console.warn('getLocation start:::::');
        window.wx &&
          window.wx.getLocation({
            type: 'gcj02', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
            success(res) {
              // const { latitude } = res; // 纬度，浮点数，范围为90 ~ -90
              // const { longitude } = res; // 经度，浮点数，范围为180 ~ -180。
              // const { speed } = res; // 速度，以米/每秒计
              // const { accuracy } = res; // 位置精度
              console.info('getLocation-result===', res);
              resolve({
                lng: res.longitude,
                lat: res.latitude,
                ...res,
              });
            },
            fail(e) {
              reject(e);
            },
          });
      })
      .catch((e) => {
        reject(e);
      });
  });
}
